export default __webpack_public_path__ + "static/media/1.e5a3f1a6.jpg";